import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
// import { environment } from 'src/environment';
import { environment } from 'src/environments/environment';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { CompanyListingModel, CompanyGridParams } from 'common/models/page-models/internship-company/internship-company/internship-company-grid.model';

@Injectable({
    providedIn: 'root'
})
export class CompanyGridDataService extends GridDataService<CompanyListingModel, CompanyModel> {
    
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.internshipCompany, http, ss);
    }

    createInstance(): CompanyListingModel {
        return new CompanyListingModel();
    }


    override getGridParams(param): GridPostParams {
         const params=new CompanyGridParams();
         params.year=param.year
        return params;
    }

    override modifyGridPostParams(queryParams){
        // console.log(queryParams,'modifyGridPostParams');
        const modifyPostParams = 
        {
            year: queryParams.year ? queryParams.year : new Date().getFullYear().toString()
        }
        return modifyPostParams;
     }

    
  
    override getDeleteUrl(){
       
            return environment.apiUrl+API_URL.internshipCompanyDelete;
    }
    // override getDeletePayload(data){
    //     let payload;
    //     if(data.id){
    //         payload={id:[data.id]}
    //     }
    //     else{
    //         payload=data;
    //     }
        
    //     return payload;
    // }
    override getDeletePayload(data) {
        let payload;
      
        if (data.id) {
            // Check if `data.id` is a string with comma-separated values
            if (typeof data.id === 'string') {
                // Split the string by commas and convert to an array of numbers
                payload = { id: data.id.split(',').map(id => parseInt(id.trim(), 10)) };
            } else {
                // If `data.id` is already an array of IDs, just assign it
                payload = { id: Array.isArray(data.id) ? data.id : [data.id] };
            }
        } else {
            // If `data.id` doesn't exist, return the original data
            payload = data;
        }
      
        return payload;
      }
}
